<script setup>
import { ref, onMounted, watch, nextTick } from "vue";

import { useCurrentMenuStore } from "../../stores/current-menu";
import SubcategoryModal from "../modals/SubcategoryModal";
import ConfirmModalVue from "../modals/ConfirmModal";

import draggable from "vuedraggable";
import MenuSubcategory from "./MenuSubcategory";

const props = defineProps({
  category: {},
  type: {
    required: true
  },
  categoryIndex: {
    required: true
  }
});

const currentMenuStore = useCurrentMenuStore();

const editing = ref(false);
const collapsed = ref(false);

const tempName = ref("");

function addSubcategory(name) {
  props.category.contents.push({
    name: name,
    active: true,
    contents: [],
  });
}


onMounted(async () => {
  document.addEventListener("mousedown", function (e) {
    if (editing.value && e.target.id !== `title-${props.categoryIndex}` && tempName.value) {
      editing.value = false;
    }
  });

  await nextTick();
  active.value = props.category.active;
});

function deleteCategory() {
  currentMenuStore[props.type].splice(props.categoryIndex, 1);
  return false;
}


const active = ref(true);

watch(active, (value) => {
  // Check categoryIndex is set
  try {
    currentMenuStore[currentMenuStore.currentTab][props.categoryIndex].active = value;
  }
  catch (error) {
    console.log(error);
  }
});

watch(editing, (value) => {

  const removeSpecialChars = tempName.value.replace(/[^a-zA-Z0-9 ]/g, '');

  if (value) {
    tempName.value = currentMenuStore[currentMenuStore.currentTab][props.categoryIndex].name;
  } else {
    currentMenuStore[currentMenuStore.currentTab][props.categoryIndex].name = removeSpecialChars;
  }
});

const renderComponent = ref(true);

const forceRerender = async (args) => {

  // Remove MyComponent from the DOM
  renderComponent.value = false;

  // Wait for the change to get flushed to the DOM
  await nextTick();

  // Add the component back in
  renderComponent.value = true;
};

</script>

<template>
  <div class="menu-item-holder" v-if="renderComponent">
    <div class="menu-item-holder__header">
      <div class="d-flex">
        <div class="handle category-handle">
          <svg viewBox="0 0 23 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M0 .5A.5.5 0 0 1 .5 0h21.92a.5.5 0 1 1 0 1H.5A.5.5 0 0 1 0 .5ZM0 6.5A.5.5 0 0 1 .5 6h21.92a.5.5 0 1 1 0 1H.5a.5.5 0 0 1-.5-.5Z"
              fill="currentColor"></path>
          </svg>
        </div>
        <input type="checkbox" v-model="active">
        <p class="can-edit" v-if="!editing" @click="editing = !editing" :id="'title-' + categoryIndex">{{ category.name
        }}
        </p>
        <input type="text" v-model="tempName" v-if="editing" :id="'title-' + categoryIndex" />
      </div>
      <div class="menu-item-holder__header--right">
        <SubcategoryModal @addSubcategory="addSubcategory">
        </SubcategoryModal>
        <div class="toggle-collapse" @click="collapsed = !collapsed" :class="{ collapsed }">
          <svg-vue icon="arrow-toggle"></svg-vue>
        </div>
      </div>
    </div>

    <draggable group="food" :list="category.contents" item-key="name" handle=".handle" @change="forceRerender">
      <template #item="{ element, index }">
        <div>
          <MenuSubcategory :categoryIndex="categoryIndex" :subcategory="{ ...element }" :subcategoryIndex="index"
            :type="type" v-if="!collapsed" :key="element.name">
          </MenuSubcategory>
        </div>
      </template>
    </draggable>
    <div class="delete-btn-container">
      <ConfirmModalVue :method="deleteCategory" :btn-content="'Delete ' + category.name + ' Category'">
        Are you sure you want to delete this category?
      </ConfirmModalVue>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.toggle-collapse {
  margin-left: 40px;
}

.menu-item-holder {
  &__header {
    background: #fff;
    padding: var(--grid-padding);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0 2px;

    @media(max-width: 600px) {
      display: block;
    }

    &--right {
      display: flex;
      align-items: center;

      @media(max-width: 600px) {
        justify-content: space-between;
        margin-top: 10px;
      }
    }
  }
}

.handle {
  margin-right: 20px;
  margin-bottom: 4px;
}

.d-flex {
  display: flex;
  align-items: center;
}

.delete-btn-container {
  margin-left: auto;
  margin-top: 2px;
  width: fit-content;
}
</style>
